import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-277d131d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "infoBox" }
const _hoisted_3 = { class: "infoLine" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLine_l" }, "项目名称", -1))
const _hoisted_5 = { class: "infoLine_r" }
const _hoisted_6 = { class: "infoLine" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLine_l" }, "项目类型：", -1))
const _hoisted_8 = { class: "infoLine_r" }
const _hoisted_9 = { class: "infoLine" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLine_l" }, "项目代号：", -1))
const _hoisted_11 = { class: "infoLine_r" }
const _hoisted_12 = { class: "infoLine" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLine_l" }, "项目负责人：", -1))
const _hoisted_14 = { class: "infoLine_r" }
const _hoisted_15 = { class: "infoLine" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLine_l" }, "项目成员：", -1))
const _hoisted_17 = { class: "infoLine_r" }
const _hoisted_18 = { class: "infoLine" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLine_l" }, "项目状态：", -1))
const _hoisted_20 = { class: "infoLine" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLine_l" }, "项目开始时间：", -1))
const _hoisted_22 = { class: "infoLine_r" }
const _hoisted_23 = { class: "infoLine" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLine_l" }, "项目结束时间：", -1))
const _hoisted_25 = { class: "infoLine_r" }
const _hoisted_26 = {
  class: "infoLine",
  style: {"width":"100%"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLine_l" }, "项目描述：", -1))
const _hoisted_28 = { class: "infoLine_r" }
const _hoisted_29 = {
  key: 0,
  class: "infoStateBtnBox"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "操作：", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode("开 始")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("延 期")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("挂 起")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("激 活")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("关 闭")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("导 出")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageMain = _resolveComponent("PageMain")!
  const _component_Iteration = _resolveComponent("Iteration")!
  const _component_HelpCenter = _resolveComponent("HelpCenter")!

  return (_ctx.info)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_PageMain, { title: "基本信息" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.info.name), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.info.type_name), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.info.code), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.info.user_type1.username), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.info.membersProject), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", {
                  class: "infoLine_r",
                  style: _normalizeStyle({ color: _ctx.statusColor[_ctx.info.status] })
                }, _toDisplayString(_ctx.info.status_str), 5)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.info.start_date), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.info.end_date), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.info.describe), 1)
              ])
            ]),
            (_ctx.info && _ctx.$globalFun.ifAuth(_ctx.$route, '状态更改'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _hoisted_30,
                  (_ctx.info.status === 1)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        size: "small",
                        type: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onStatus(2, '开始')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_31
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.info.status === 2)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        size: "small",
                        type: "warning",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onStatus(3, '延期')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_32
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.info.status === 2)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        size: "small",
                        type: "danger",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onStatus(4, '挂起')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_33
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.info.status === 3 || _ctx.info.status === 4)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 3,
                        size: "small",
                        type: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onStatus(2, '激活')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.info.status !== 1 && _ctx.info.status !== 5)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 4,
                        size: "small",
                        type: "info",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onStatus(5, '关闭')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_35
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.info.status !== 1)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 5,
                        size: "small",
                        type: "success",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onExport()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_36
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.$globalFun.ifAuth(_ctx.$route, '迭代-列表'))
          ? (_openBlock(), _createBlock(_component_PageMain, {
              key: 0,
              title: "迭代管理"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Iteration)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_PageMain, { title: "帮助中心管理" }, {
          default: _withCtx(() => [
            _createVNode(_component_HelpCenter)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}